module["exports"] = [
  "+91###-###-####",
  "+91##########",
  "+91-###-#######"
];
